import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import InspectForm from '../form/inspect'
import {TableObservationByInpsectWrapper} from './component/table/observation'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../../models'
import IconButton from '../../../../../../components/UI/Button/IconButton'
const InspectTab = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()

  const handleBack = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_content_tab_panel'>
      {isDisabled && <IconButton onClick={handleBack} color='#283897' />}

      <Tabs className={'sdx_sub_react_tab_panel '}>
        <TabList className={'sdx_sub_tab_panel p-0'}>
          <Tab className={'sdx_sub_tab_panel_option'}>Actualizar Registro</Tab>
          {isAllowed('OBSERVACION/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Observaciones</Tab>
          )}
        </TabList>
        <TabPanel>
          <InspectForm />
        </TabPanel>
        {isAllowed('OBSERVACION/ACCESO') && (
          <TabPanel>
            <TableObservationByInpsectWrapper />
          </TabPanel>
        )}
      </Tabs>
    </div>
  )
}

export default InspectTab
